import { checkBitrixResponse } from 'tools';

export default class B2bBalance {
    constructor() {
        this.$balanceButton = $('.b2b-balance button');
        this.bind();
    }
    bind() {
        this.$balanceButton.on('click', this.getBalance.bind(this));
    }

    getBalance() {
        this.$balanceButton.prop('disabled', true);
        $.ajax({
            url: `/bitrix/services/main/ajax.php?c=${encodeURIComponent('nav:b2b.balance')}&mode=class&action=getBalance`,
            data: {
                sessid: app.sessid,
            },
            type: 'get',
        }).done((response) => {
            if (!checkBitrixResponse(response)) {
                return;
            }
            if (response.data.status == "ok") {
                if (response.data.balance > 0) {
                    $(".b2b-balance__item--balance .b2b-balance__price").addClass('b2b-balance__price--positive');
                } else if (response.data.balance != 0) {
                    $(".b2b-balance__item--balance .b2b-balance__price").addClass('b2b-balance__price--negative');
                }
                $(".b2b-balance__item--balance .b2b-balance__price").text(response.data.balance_formatted);
                $(".b2b-balance__item--prod .b2b-balance__price").text(response.data.prod_formatted);
                $(".b2b-balance__balance-container").removeClass("hidden");
            } else {
                alert(response.data.error);
            }
        });
    }
}
